import React from "react";
import KaagazyLogoMobile from "../assets/logo-teal-mobile.png";
import KaagazyLogoWhite from "../assets/logo-white.png";

type AuthLayoutProps = {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  heroTitleLine1?: string;
  heroTitleLine2?: string;
  heroBody?: React.ReactNode;
};

const AuthLayout: React.FC<AuthLayoutProps> = ({
  title,
  subtitle,
  children,
  heroTitleLine1,
  heroTitleLine2,
  heroBody,
}) => {
  const line1 = heroTitleLine1 ?? "Welcome back";
  const line2 = heroTitleLine2 ?? "Login to continue";

  return (
    <div className="min-h-screen flex">
      {/* ── Left gradient panel — full height, edge-to-edge ── */}
      <div
        className="hidden md:flex w-[40%] flex-col relative"
        style={{
          background:
            "linear-gradient(160deg, #6366f1 0%, #007cf0 35%, #00b3ff 65%, #00dfd8 100%)",
        }}
      >
        {/* Branding */}
        <div className="absolute top-0 left-6 lg:left-4">
          <img
            src={KaagazyLogoWhite}
            alt="Kaagazy"
            className="h-72 object-contain"
            style={{ mixBlendMode: "screen", marginTop: "-60px" }}
          />
        </div>

        {/* Hero text */}
        <div className="flex-1 flex flex-col justify-center px-10 lg:px-14 text-white">
          <h1 className="text-[40px] lg:text-[48px] font-medium leading-[1.1] tracking-tight">
            {line1}
            <br />
            {line2}
          </h1>
          {heroBody && <div className="mt-4 text-white/90 text-sm max-w-sm">{heroBody}</div>}
        </div>
      </div>

      {/* ── Right panel ── */}
      <div className="flex w-full md:w-[60%] items-center justify-center bg-white overflow-y-auto">
        <div className="w-full max-w-md px-8 py-10 md:px-12 md:py-12">
          {/* Mobile branding */}
          <div className="md:hidden mb-4 flex justify-center">
            <img
              src={KaagazyLogoMobile}
              alt="Kaagazy"
              className="h-10 object-contain"
            />
          </div>

          <h2 className="text-2xl font-semibold text-slate-900 mb-1">{title}</h2>
          {subtitle && (
            <p className="text-sm text-slate-500 mb-6">{subtitle}</p>
          )}
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
